
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VKVirkeskostnadDTO } from "../../dto/virkeskostnader/virkeskostnader-dto";
import { Virkeskostnad } from "../../models/virkeskostnader/virkeskostnader-models";
import { VirkeskostnadBaseCommand } from "./VirkeskostnadBaseCommand";

export class UpdateVirkeskostnaderCommand extends VirkeskostnadBaseCommand {
    virkeskostnad: VKVirkeskostnadDTO;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateVirkeskostnaderCommand";

    constructor(kostnad: Virkeskostnad, atgardGuid: string, kontraktGuid: string) {
        super(UpdateVirkeskostnaderCommand.$type, CommandType.Replace);
        this.guid = kostnad.guid;
        this.virkeskopsatgardGuid = atgardGuid;
        this.virkeskopskontraktGuid = kontraktGuid;
        this.virkeskostnad = {
            id: kostnad.id,
            guid: kostnad.guid,
            mattslag: kostnad.mattslag,
            kvantitet: kostnad.kvantitet,
            grundpris: kostnad.grundpris,
            tillaggAvdrag: kostnad.tillaggAvdrag,
            fsc: kostnad.fsc,
            pefcSC: kostnad.pefcSC,
            tackningsbidrag: kostnad.tackningsbidrag,
            handelssortimentId: kostnad.handelssortimentId,
            handelssortimentNamn: kostnad.handelssortimentNamn,
            handelssortimentsgruppId: kostnad.handelssortimentsgruppId,
            handelssortimentsgruppNamn: kostnad.handelssortimentsgruppNamn,
            handelssortimentsgruppSekvensnummer: kostnad.handelssortimentsgruppSekvensnummer,
            konverteringsfaktorHandelssortimentMattslag: kostnad.konverteringsfaktorHandelssortimentMattslag,
            utbyteInlastKvantitet: kostnad.utbyteInlastKvantitet
        } as VKVirkeskostnadDTO;
    }
}
